import React from "react";
import { IoMdAlert } from "react-icons/io";
import "./index.css";
import AuthService from "../../Auth";
import { APP_CONFIG } from "../../AppConfig";

const Unauthorized = (props) => {
  const handleLogout = async () => {
    try {
      await AuthService.logout();
      window.location.href = `${APP_CONFIG.SIGNIN_URL}`;
    } catch (error) {
      console.log("Error signing out: ", error);
    }
  };
  return (
    <div className="unauthorized-container">
      <div className="icon-container">
        <IoMdAlert className="unicon" />
      </div>
      <h1>Unauthorized</h1>
      <p>You don't have permission to access this page.</p>
      <button className="retry-button" onClick={handleLogout}>
        Retry
      </button>
    </div>
  );
};

export default Unauthorized;
